var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('custom-animation',{staticClass:"loading",attrs:{"data":_vm.animationData,"speed":"1","custom":"top: 45%; left: 48%;"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }